<!--福利活动-->
<template>
  <div class="comp-activity">
    <!-- 内容区 -->
    <div class="hd-title">
      <span>{{name}}</span>
    </div>
    <div class="hd-cont">
      <ul>
        <li v-for="(item, index) in activityData" :key="index" v-if="item.operationType === 1" @click="goToThirdPage(item.activityUrl)"><img :src="item.image"></li>
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'activity',
  data() {
    return {
      name: '福利活动',
    }
  },
  props: {
    activityData: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    
  },
  methods: {
    goToThirdPage(url) {
      this.$router.push({
        name: 'ThirdPage',
        query: {
          url: url,
        }
      });
    }
  },
  created() {

  }
}
</script>

<style scoped lang="stylus">
  .comp-activity
    width: 100%
    background-color: #fff
    margin-top: .2rem
    padding: 0 .3rem .1rem .3rem
    .hd-title
      display: flex
      height: 1.12rem
      align-items: center
      span
        text-align: left
        font-size: .34rem
        color: #333
        font-weight: 500
    .hd-cont
      ul
        li
          width: 100%
          //height: 1.72rem
          background-color: #e5e5e5
          border-radius: .08rem
          margin-bottom: .3rem
          img
            display: block
            width: 100%
            height: 100%


</style>
